import * as React from "react";
import { useTranslation } from "react-i18next";

export interface ChangedNameActivityProps {
  activity: any;
}

export function ChangedNameActivity({
  activity,
}: ChangedNameActivityProps): JSX.Element {
  const { actor, insertedAt } = activity;
  const { t } = useTranslation("ai.workflows.activities");

  return (
    <div>
      {t("ChangedNameActivity", {
        actorName: actor.name,
        insertedAt,
      })}
    </div>
  );
}
